var _rect, _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 68,
    viewBox: "0 0 72 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    transform: "translate(0 9)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 34,
    r: 34,
    fill: "#00CFC5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3357 28.0009C48.7121 25.8486 47.6488 23.8491 46.2131 22.1287C44.7773 20.4084 43.0003 19.0045 40.9944 18.0059C38.9884 17.0073 36.7971 16.4357 34.559 16.3271C32.3208 16.2186 30.0845 16.5755 27.9913 17.3753C25.8981 18.1751 23.9936 19.4005 22.3981 20.9738C20.8026 22.5472 19.5509 24.4344 18.7219 26.5163C17.893 28.5981 17.5049 30.8292 17.5823 33.0687C17.6596 35.3081 18.2006 37.5072 19.1711 39.5269",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 30.5999L31.3 37.5333M38.5 30.5999L45.7 37.5333M38.5 30.5999L38.5 52.2666",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7094 28.4736C49.318 28.0448 50.0051 27.7402 50.7314 27.577C51.4578 27.4138 52.2091 27.3953 52.9426 27.5225C53.6761 27.6497 54.3774 27.9201 55.0064 28.3183C55.6354 28.7165 56.1798 29.2347 56.6086 29.8433C57.0373 30.4519 57.3419 31.139 57.5051 31.8654C57.6683 32.5917 57.6868 33.3431 57.5597 34.0766C57.4325 34.8101 57.162 35.5114 56.7638 36.1404C56.3656 36.7694 55.8474 37.3138 55.2388 37.7425",
    stroke: "white",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.585b8be8e375889d12629d36aeda4ee9.svg";
export { ForwardRef as ReactComponent };